// extracted by mini-css-extract-plugin
export default {"price":"F6-z","onSale":"G6-z","msrpLabelPrice":"H6-z","msrpLabel":"I6-z","originalPrice":"J6-z","percentOff":"K6-z"};